import clsx from "clsx";
import { View } from "../View";
import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  circleIconBase: {
    borderRadius: "50%",
    width: "24px",
    height: "24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    backgroundColor: (props) =>
      props.disabled
        ? props.disabledColor || props.defaultColor
        : props.defaultColor,
  },
  left10: {
    marginLeft: "10px",
  },
});

export const CircleButton = ({
  disabled,
  defaultColor,
  disabledColor,
  icon,
  onClick,
}) => {
  const styles = useStyles({ defaultColor, disabledColor, disabled });

  return (
    <View
      className={clsx(styles.circleIconBase, styles.left10)}
      onClick={() => {
        !disabled && onClick();
      }}
    >
      {icon}
    </View>
  );
};
